import { createContractService, fetchVehicleAllContracts } from "../../services/contractService";
import { vehicleAllContractFetched } from "../actions/vehicleAllContractsAction";
import { createAllActionCreators } from "./actionCreatorUtil";

const contractActionCreators = {
  fetchAllContractAction: {
    service: fetchVehicleAllContracts,
    action: vehicleAllContractFetched,
  },
  createContractAction: {
    service: createContractService,
    responseNotification: {
      status: true,
      only: true,
    },
  },
};

export const {
  fetchAllContractAction,
  createContractAction,
} = createAllActionCreators(contractActionCreators);
